var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutTelas',{attrs:{"id":"tela__filiais","titulo":this.$route.meta.titulo,"isLoading":_vm.isLoading}},[_c('FiliaisCadastroForm',{ref:"formFilial",attrs:{"dados":_vm.dadosUsuario},on:{"gravar":_vm.gravar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }